import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/conference/$id')({
  loader: ({ params }) =>
    redirect({
      statusCode: 301,
      throw: false,
      to: `/meeting/${params.id}`,
    }),
})
